import dayjs from 'dayjs';
import { jsPDF } from 'jspdf';
import { DocMessage } from '../model/type';

import { callAddFont as addAeroportNotoSansArabic } from '@shared/assets/fonts/Aeroport/Airport-NotoSansArabic-Regular-normal';
import { callAddFont as addAeroportNotoSansArabicBold } from '@shared/assets/fonts/Aeroport/Airport-NotoSansArabic-Bold-bold';

const createPdf = () => {
  const doc = new jsPDF();
  // register fonts to VFS
  addAeroportNotoSansArabic.call(doc);
  addAeroportNotoSansArabicBold.call(doc);
  return doc;
};

const removeEmojis = (text: string): string =>
  text.replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD00-\uDDFF])/g,
    '',
  );

export const downloadDialogAsPdf = async (recipient: string, dialog: DocMessage[]) => {
  const doc = createPdf();
  doc.setFontSize(16);
  const title = `Ongoing call with ${recipient}`;
  const pageWidth = doc.internal.pageSize.getWidth();
  const textWidth = doc.getTextWidth(title);
  const x = (pageWidth - textWidth) / 2;
  doc.setFontSize(12);
  doc.setFont('Airport-NotoSansArabic-Regular', 'normal');

  doc.text(title, x, 15);

  let y = 25;
  const maxWidth = 180;

  dialog.forEach((entry: DocMessage, index) => {
    const actorText = `${entry.actor}`;
    const messagedAt = dayjs(entry.createdAt).local().format('YYYY-MM-DD HH:mm:ss');
    const restText = ` (at ${messagedAt}):\n ${removeEmojis(entry.message)}`;

    const fullLine = `${actorText}${restText}`;
    const lines = doc.splitTextToSize(fullLine, maxWidth);

    // checking if there is available space on the page
    if (y + lines.length * 10 > 280 && index !== dialog.length - 1) {
      doc.addPage();
      y = 10;
    }

    // render first line
    const firstLine = lines[0];
    const actorWidth = doc.getTextWidth(actorText);

    doc.setFont('Airport-NotoSansArabic-Bold', 'bold');
    doc.text(actorText, 10, y);

    doc.setFont('Airport-NotoSansArabic-Regular', 'normal');
    doc.text(firstLine.slice(actorText.length), 10 + actorWidth, y);

    // render message lines
    for (let i = 1; i < lines.length; i++) {
      y += 10;
      doc.text(lines[i], 10, y);
    }

    // empty row after message log
    y += 20;
  });

  const callDate = dayjs(dialog[0].createdAt).local().format('YYYY-MM-DD-HH:mm:ss');

  doc.save(`chat-history-${recipient}-${callDate}.pdf`);
};

export const openDialogAsPdf = async (recipient: string, dialog: DocMessage[]) => {
  const doc = createPdf();
  doc.setFontSize(16);
  const title = `Ongoing call with ${recipient}`;
  const pageWidth = doc.internal.pageSize.getWidth();
  const textWidth = doc.getTextWidth(title);
  const x = (pageWidth - textWidth) / 2;
  doc.setFontSize(12);
  doc.setFont('Airport-NotoSansArabic-Regular', 'normal');

  doc.text(title, x, 15);

  let y = 25;
  const maxWidth = 180;

  dialog.forEach((entry: DocMessage, index) => {
    const actorText = `${entry.actor}`;
    const messagedAt = dayjs(entry.createdAt).local().format('YYYY-MM-DD HH:mm:ss');
    const restText = ` (at ${messagedAt}):\n ${removeEmojis(entry.message)}`;

    const fullLine = `${actorText}${restText}`;
    const lines = doc.splitTextToSize(fullLine, maxWidth);

    if (y + lines.length * 10 > 280 && index !== dialog.length - 1) {
      doc.addPage();
      y = 10;
    }

    const firstLine = lines[0];
    const actorWidth = doc.getTextWidth(actorText);

    doc.setFont('Airport-NotoSansArabic-Bold', 'bold');
    doc.text(actorText, 10, y);

    doc.setFont('Airport-NotoSansArabic-Regular', 'normal');
    doc.text(firstLine.slice(actorText.length), 10 + actorWidth, y);

    for (let i = 1; i < lines.length; i++) {
      y += 10;
      doc.text(lines[i], 10, y);
    }

    y += 20;
  });

  const pdfDataUri = doc.output('datauristring');
  window.open(pdfDataUri, '_blank');
};
